import { CanActivateFn, Router } from '@angular/router';
import { inject } from '@angular/core';
import { AuthenticationService } from '../services/authentication.service';
import { FeatureStore } from '../stores/feature-store';

export const askAaliyahAccessGuard: CanActivateFn = (route, state) => {
  const router = inject(Router);
  const nav = router.currentNavigation();

  if (!inject(AuthenticationService).isUserLoggedIn()) {
    return router.parseUrl('/login' + (nav?.finalUrl ? `?redirect=${nav.finalUrl.toString()}` : ''));
  }

  const featureStore = inject(FeatureStore);

  if (!featureStore.isFeatureLive('ask-aaliyah-feature')) {
    return router.parseUrl('/dashboard');
  }

  if (featureStore.hasFeature('ask-aaliyah-feature')) {
    return true;
  }
  return router.parseUrl('/ask-aaliyah/non-premium');
};
